export default __webpack_public_path__ + "static/media/runkeeper-wireframes.e91ae438.svg";